// extracted by mini-css-extract-plugin
export var colorAzure = "Card-module--colorAzure--60ec2";
export var colorCove = "Card-module--colorCove--f701d";
export var full = "Card-module--full--56fc2";
export var noPadding = "Card-module--noPadding--0cc94";
export var paddingMedium = "Card-module--paddingMedium--e5cbf";
export var root = "Card-module--root--f0942";